<template>
  <div class="main">
    <div v-if="step==='upgrade'" class="systemUpgrade">
      <div class="systemUpgrade-main">
        <module-title title="应用管理">
          <div class="right">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-plus"
              @click="opAddOrEdit('add')"
            >
              添加应用
            </el-button>
          </div>
        </module-title>
        <div class="systemUpgrade-main-contain">
          <el-form ref="searchForm" :model="searchForm" :inline="true" label-position="right" label-width="100px" :rules="searchRules">
            <el-form-item label="应用名称：" prop="name">
              <el-input
                v-model="searchForm.name"
                name="name"
                placeholder="请输入应用名称"
              />
            </el-form-item>
            <el-form-item label="更新时间：" prop="dateTime">
              <el-date-picker
                v-model="dateValue"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="dateChange"
                @focus="dafaultVulue"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleSearchFilter"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="medium"
                @click="resetInput"
              >
                重置
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="applicationList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="应用名称" prop="name" width="150" align="center" />
            <el-table-column label="应用标识" prop="code" align="center" />
            <el-table-column label="终端设备" prop="terminalTypeName" align="center" />
            <el-table-column label="设备类型" prop="deviceTypeName" align="center" />
            <el-table-column label="平台" prop="platformTypeName" />
            <el-table-column label="应用图标" prop="logoUrl" align="center">
              <template slot-scope="scope">
                <img v-show="scope.row.logoUrl" :src="scope.row.logoUrl" width="48" height="48">
              </template>
            </el-table-column>
            <el-table-column label="应用描述" prop="summary" width="200" align="center">
              <template slot-scope="{ row }">
                <span :title="row.summary">{{ row.summary| substring(50) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="升级范围" prop="upgradeTypeName" show-overflow-tooltip />
            <el-table-column label="升级方式" prop="upgradeMethodOptions">
              <template slot-scope="scope">
                <div
                  v-for="(item,index) in scope.row.upgradeMethodOptions"
                  :key="index"
                >
                  {{ item.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="更新时间" prop="updateDate" width="150px" show-overflow-tooltip />
            <el-table-column label="启用状态" prop="statusName" align="center" />
            <el-table-column label="操作" align="center" width="300px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="opAddOrEdit('edit', scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  v-show="scope.row.status===1 || scope.row.status===0"
                  type="danger"
                  size="small"
                  @click="stopApplication(scope.row)"
                >
                  {{ scope.row.status ===1 ?'停用':'启用' }}
                </el-button>
                <el-button
                  v-if="typeCode!=='B14'"
                  type="primary"
                  size="small"
                  @click="groupConfig(scope.row)"
                >
                  分组配置
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
      <!-- 新增编辑升级 -->
      <el-dialog
        v-if="hiddenVariable.dialogEditVisible"
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogEditVisible"
        :title="handleType === 'add' ? '新增应用' : '编辑应用'"
        width="700px"
        @close="handleDialogClose"
      >
        <el-form
          ref="addApplicationForm"
          :model="addApplicationForm"
          :rules="handleRules"
          label-position="right"
          label-width="150px"
        >
          <el-form-item label="应用名称：" prop="name">
            <el-input
              v-model="addApplicationForm.name"
              placeholder="请输入应用名称"
              name="name"
              class="handle-form-input"
            />
          </el-form-item>
          <el-form-item label="应用标识：" prop="code">
            <el-input
              v-model="addApplicationForm.code"
              placeholder="请输入应用标识"
              name="code"
              class="handle-form-input"
              :disabled="handleType === 'edit'"
            />
            <el-tooltip
              class="item"
              effect="dark"
              content="
              可输入50个字符，字符类型为数字、字母，不可输入已存在的应用标识。"
              placement="right"
            >
              <span>
                <img width="30px" class="tips-img" src="@/assets/img/tips.png" alt="">
              </span>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="终端设备：" prop="terminalTypeCode">
            <el-select
              v-model="addApplicationForm.terminalTypeCode"
              placeholder="请选择终端设备"
              name="terminalTypeCode"
              size="medium"
              class="handle-form-input"
            >
              <el-option
                v-for="item in terminalList"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型：" prop="deviceTypeCode">
            <el-select
              v-model="addApplicationForm.deviceTypeCode"
              placeholder="请选择设备类型"
              name="deviceTypeCode"
              class="handle-form-input"
              size="medium"
            >
              <el-option
                v-for="item in deviceTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="平台：" prop="platformTypeId">
            <el-select
              v-model="addApplicationForm.platformTypeId"
              placeholder="请选择平台"
              name="platformTypeId"
              size="medium"
              class="handle-form-input"
              @change="handlePlatformType"
            >
              <el-option
                v-for="item in platformList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="addApplicationForm.platformTypeId==='1003000004'" label="appId：" prop="appId">
            <el-input
              v-model="addApplicationForm.appId"
              name="appId"
              class="handle-form-input"
              maxlength="200"
            />
          </el-form-item>
          <el-form-item v-if="addApplicationForm.platformTypeId==='1003000004'" label="Bundle ID：" prop="packageName">
            <el-input
              v-model="addApplicationForm.packageName"
              name="packageName"
              class="handle-form-input"
              maxlength="200"
            />
          </el-form-item>

          <el-form-item label="升级包类型：" prop="upgradeWay">
            <el-select
              v-model="addApplicationForm.upgradeWay"
              name="upgradeWay"
              size="medium"
              placeholder="请选择升级包类型"
              class="handle-form-input"
            >
              <el-option
                v-for="item in arr3"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="应用图标：" prop="logoUrl">
            <upload-file
              :props="{serveCode:'app_logo',accept:'.png, .jpg, .jpeg',type:['image/jpeg','image/gif','image/png'],fileSize:10}"
              @uploadSucess="uploadSucessImgFn"
              @typeError="typeError"
            >
              <div v-if="addApplicationForm.logoUrl" style="font-size:12px;line-height: 28px;">
                <img :src="addApplicationForm.logoUrl" class="avatar">
                <i class="el-icon-refresh" /> <span>重新上传</span>
              </div>

              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </upload-file>
          </el-form-item>
          <el-form-item label="应用简介：" prop="summary">
            <el-input
              v-model="addApplicationForm.summary"
              type="textarea"
              :rows="6"
              placeholder="请输入内容"
              class="handle-form-input"
              maxlength="1000"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="升级对象：" prop="upgradeType">
            <el-select
              v-model="addApplicationForm.upgradeType"
              name="upgradeType"
              size="medium"
              placeholder="请选择最小升级对象"
              class="handle-form-input"
            >
              <el-option
                v-for="item in arr1"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="升级方式：" prop="upgradeMethodOptions">
            <el-select
              v-model="addApplicationForm.upgradeMethodOptions"
              name="upgradeMethodOptions"
              size="medium"
              placeholder="请选择升级方式"
              class="handle-form-input"
              multiple
            >
              <el-option
                v-for="item in arr2"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            size="medium"
            @click="hiddenVariable.dialogEditVisible = false"
          >
            取消
          </el-button>
          <el-button
            :loading="ajaxLoading"
            type="primary"
            size="medium"
            @click="handleAddUpgrade"
          >
            {{ ajaxLoading ? 'Loading' : '确定' }}
          </el-button>
        </div>
      </el-dialog>
    </div>
    <group-config v-else :campus-app-id="handleRow.id" :type-code="typeCode" @back="back" />
  </div>
</template>

<script>
import { getDictsType } from '@/api/productOperation/common/applicationManage';
import {
  getDeviceTypeList
} from '@/api/systemMaintenance/upgradeManage/systemUpgrade';
import { campusAppsList, campusAppAdd, campusAppsDisable, campusAppEnable, campusAppUpdate } from '@/api/systemManage/softwareUpdate';
import GroupConfig from './groupConfig.vue';
import { getDateTime } from '@/utils/index';
export default {
  name: 'SystemUpgrade',
  components: {
    GroupConfig
  },
  props: {
    typeCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ajaxLoading: false,
      step: 'upgrade',
      // 弹框标题
      handleType: 'add',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false
      },
      // 搜索表单
      searchForm: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        name: '',
        startUpdateDate: null,
        endUpdateDate: null
      },
      dateValue: '',
      addApplicationForm: {
        name: '',
        platformTypeId: '',
        terminalTypeCode: '',
        code: '',
        deviceTypeCode: '',
        upgradeType: '', // 升级范围
        upgradeMethodOptions: [], // 类型：String  必有字段  备注：是否强制升级
        logoPath: '',
        logoUrl: '',
        summary: '',
        appId: '',
        packageName: '',
        upgradeWay: ''
      },
      listLoading: false, // 表格刷新loading
      applicationList: [],
      platformList: [], //  平台列表
      terminalList: [], //  终端列表
      deviceTypeList: [], //  设备类型列表
      handleRow: {},
      arr1: [
        { code: 0, name: '全部升级' },
        { code: 1, name: '到班级' },
        { code: 2, name: '到教室' }
      ],
      arr2: [
        { code: '1', name: '强制升级' },
        { code: '2', name: '非强制升级' }
      ],
      arr3: [
        { code: 1, name: '全量' },
        { code: 2, name: '增量' }
      ],
      searchRules: { name: [{ max: 50, message: '请输入50以内的字符', trigger: 'blur' }] },
      handleRules: {
        terminalTypeCode: [{ required: true, message: '该项为必填项', trigger: 'blur' }],
        platformTypeId: [{ required: true, message: '该项为必填项', trigger: 'blur' }],
        name: [{ required: true, message: '该项为必填项', trigger: 'blur' }, { max: 50, message: '请输入50以内的字符', trigger: 'blur' }],
        code: [{ required: true,
          trigger: 'blur',
          validator: (rule, value, callback) => {
            const pattern = new RegExp(/^[\dA-Za-z\s*]+$/);
            if (value === '') {
              callback(new Error('该项为必填项'));
            } else if (!pattern.test(value)) {
              callback(new Error('请输入数字或字母字符'));
            } else if (value.toString().length > 50) {
              callback(new Error('请输入50以内的字符'));
            } else {
              callback();
            }
          }
        }],
        deviceTypeCode: [{ required: true, message: '该项为必填项', trigger: 'blur' }],
        upgradeType: [{ required: true, message: '该项为必填项', trigger: 'blur' }],
        upgradeWay: [{ required: true, message: '该项为必填项', trigger: 'blur' }],
        upgradeMethodOptions: [{ required: true, message: '该项为必填项', trigger: 'blur' }],
        summary: [{ max: 1000, message: '请输入1000以内的字符', trigger: 'blur' }],
        // logoUrl: [{ required: true, message: '该项为必填项', trigger: 'blur' }],
        appId: [{ required: true, message: 'appId不能为空', trigger: 'blur' }],
        packageName: [{ required: true, message: 'packageName不能为空', trigger: 'blur' }]
      },
      option: {}
    };
  },
  mounted() {
    this.fetchApplicationList();
    this.fetchPlatformList();
    this.fetchTerminalList();
    this.fetchDeviceTypeList();
  },
  methods: {
    dafaultVulue() {
      this.dateValue = [getDateTime(-1), getDateTime(-1)];
      this.searchForm.startUpdateDate = this.dateValue[0];
      this.searchForm.endUpdateDate = this.dateValue[1];
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchApplicationList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchApplicationList();
    },
    resetInput() {
      this.searchForm.name = '';
      this.dateValue = '';
      this.searchForm.startUpdateDate = null;
      this.searchForm.endUpdateDate = null;
      this.fetchApplicationList();
    },
    // 条件查询
    handleSearchFilter() {
      this.$refs['searchForm'].validate((valid) => {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 10;
        this.option = {
          name: this.searchForm.name,
          startUpdateDate: this.searchForm.startUpdateDate,
          endUpdateDate: this.searchForm.endUpdateDate
        };
        this.fetchApplicationList();
      });
    },
    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      this.handleDialogClose();
      this.handleType = type;
      this.hiddenVariable.dialogEditVisible = true;
      if (type === 'edit') {
        this.handleRow = row;
        const {
          name,
          platformTypeId,
          terminalTypeCode,
          code,
          deviceTypeCode,
          upgradeType,
          upgradeWay,
          upgradeMethodOptions,
          logoPath,
          logoUrl,
          summary,
          status,
          appId,
          packageName
        } = row;
        this.addApplicationForm = {
          name,
          platformTypeId,
          terminalTypeCode,
          code,
          deviceTypeCode,
          upgradeType,
          upgradeWay,
          upgradeMethodOptions: upgradeMethodOptions.map(item => item.code),
          logoPath,
          logoUrl,
          summary,
          status,
          appId,
          packageName
        };
      }
    },
    dateChange(e) {
      if (e) {
        this.searchForm.startUpdateDate = e[0];
        this.searchForm.endUpdateDate = e[1];
      } else {
        this.searchForm.startUpdateDate = null;
        this.searchForm.endUpdateDate = null;
      }
    },
    // 重置
    handleDialogClose() {
      this.addApplicationForm = {
        name: '',
        platformTypeId: '',
        terminalTypeCode: '',
        code: '',
        deviceTypeCode: '',
        upgradeType: '',
        upgradeWay: '',
        upgradeMethodOptions: [],
        logoPath: '',
        logoUrl: '',
        summary: '',
        appId: '',
        packageName: ''
      };
    },
    back() {
      this.step = 'upgrade';
      this.fetchApplicationList();
    },
    // 新增编辑应用升级
    handleAddUpgrade() {
      this.$refs['addApplicationForm'].validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          this.addApplicationForm.typeCode = this.typeCode;
          if (this.handleType === 'add') {
            campusAppAdd(this.addApplicationForm)
              .then((result) => {
                this.$notify.success({
                  title: 'Success',
                  message: '添加成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this.hiddenVariable.dialogEditVisible = false;
                this.fetchApplicationList();
              })
              .catch((err) => {
                console.log(err);
                this.ajaxLoading = false;
              });
          } else {
            campusAppUpdate(this.handleRow.id, this.addApplicationForm)
              .then((result) => {
                this.$notify.success({
                  title: 'Success',
                  message: '编辑成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this.hiddenVariable.dialogEditVisible = false;
                this.fetchApplicationList();
              })
              .catch((err) => {
                console.log(err);
                this.ajaxLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          this.ajaxLoading = false;
          return false;
        }
      });
    },

    // 停用启用应用
    stopApplication(row) {
      const name = row.status === 1 ? '停用' : '启用';
      this.$confirm(`您确定要${name}当前应用吗？`, `${name}应用`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var ids = [row.id] + '';
          if (row.status === 1) {
            return campusAppsDisable({ ids });
          } else {
            return campusAppEnable({ ids });
          }
        })
        .then((res) => {
          this.$notify.success({
            title: 'Success',
            message: name + '成功',
            showClose: false,
            duration: 2000
          });
          this.fetchApplicationList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分组配置
    groupConfig(row) {
      console.log(row);
      this.handleRow = row;
      this.step = 'groupConfig';
    },
    // 获取应用列表
    fetchApplicationList() {
      this.listLoading = true;
      // this.searchForm.typeCode = this.typeCode;
      campusAppsList({ ...this.option, pageNum: this.searchForm.pageNum, pageSize: this.searchForm.pageSize }, this.typeCode)
        .then((result) => {
          this.applicationList = result.data.list;
          this.searchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.listLoading = false;
          this.applicationList = [];
          this.searchForm.total = 0;
        });
    },
    // 获取平台字典
    fetchPlatformList(type) {
      getDictsType('b_platform_type')
        .then((result) => {
          this.platformList = result.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取设备类型列表
    fetchDeviceTypeList(type) {
      getDeviceTypeList()
        .then((res) => {
          this.deviceTypeList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取终端字典
    fetchTerminalList(type) {
      getDictsType('b_terminal_type')
        .then((result) => {
          this.terminalList = result.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    typeError(val) {
      this.$message({
        type: 'error',
        message: `上传图片大小不超过${val.fileSize}MB！`
      });
    },
    uploadSucessImgFn(val) {
      this.addApplicationForm.logoPath = val.relativePath;
      this.addApplicationForm.logoUrl = val.absolutePath;
    },
    handlePlatformType(val) {
      console.log(val);
      if (val !== '1') {
        this.addApplicationForm.appId = '';
        this.addApplicationForm.packageName = '';
      }
    }
  }
};
</script>
<style lang="scss">
.systemUpgrade {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
}
</style>
<style lang="scss" scoped>
.systemUpgrade {
  padding-bottom: 20px;
  .el-date-editor.el-input {
    margin-left: 20px;
  }
  .handle-form-input {
    width: 80%;
  }
}
.tips-img{
  position: absolute;
  top: 2px;
  right: 65px;
  cursor: pointer;
}
</style>
